"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAECardInput = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.promise.js");

var _react = _interopRequireWildcard(require("react"));

var _stripeJs = require("@stripe/stripe-js");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

var _FAEText = require("../FAEText/FAEText");

var _FAEButton = require("../FAEButton/FAEButton");

require("./FAECardInput.scss");

const _excluded = ["onError", "onSuccess"],
      _excluded2 = ["justify", "align", "className", "primary", "shadowBoxProps", "loading", "loaderProps", "label", "stripeKey", "error", "onSuccess"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const CheckoutForm = _ref => {
  let {
    onError = () => {},
    onSuccess = () => {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [disableButton, setDisableButton] = (0, _react.useState)(false);
  const stripe = (0, _reactStripeJs.useStripe)();
  const elements = (0, _reactStripeJs.useElements)();

  const handleSubmit = async event => {
    event.preventDefault();
    setDisableButton(true);
    const {
      error,
      token
    } = await stripe.createToken(elements.getElement(_reactStripeJs.CardElement));
    error === undefined ? tokenGenerated(token) : someError(error);
  };

  const tokenGenerated = token => {
    setDisableButton(false);
    onSuccess(token);
  };

  const someError = error => {
    setDisableButton(false);
    onError(error);
  };

  return /*#__PURE__*/_react.default.createElement("form", {
    className: "fae--card-input-main-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_reactStripeJs.CardElement, _extends({}, rest, {
    options: {
      hidePostalCode: true
    }
  })), /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, {
    className: "fae--card-input-submit-button",
    type: "submit",
    disabled: !stripe || disableButton
  }, disableButton ? "Please wait..." : "Add Card"));
};

const FAECardInput = _ref2 => {
  let {
    justify,
    align,
    className,
    primary,
    shadowBoxProps,
    loading,
    loaderProps,
    label = "",
    stripeKey = "",
    error = () => {},
    onSuccess = () => {}
  } = _ref2,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, primary ? /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({}, shadowBoxProps, {
    padding: true
  }), loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement(_reactStripeJs.Elements, {
    stripe: (0, _stripeJs.loadStripe)(stripeKey)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--card-input-main-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(CheckoutForm, _extends({
    onError: error,
    onSuccess: onSuccess
  }, rest))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement(_reactStripeJs.Elements, {
    stripe: (0, _stripeJs.loadStripe)(stripeKey)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--card-input-main-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(CheckoutForm, _extends({
    onError: error,
    onSuccess: onSuccess
  }, rest)))))));
};

exports.FAECardInput = FAECardInput;